module.exports = __webpack_public_path__ + "static/media/noisy.a9343a6f.png";